/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.ts to modify the generation of this file.
import * as AhaPdcFeaturedProviders from 'src/components/AhaPdcFeaturedProviders';
import * as AhaPecArticle from 'src/components/AhaPecArticle';
import * as ActionLink from 'src/components/atoms/ActionLink';
import * as Button from 'src/components/atoms/Button';
import * as CustomButton from 'src/components/atoms/CustomButton';
import * as CustomInput from 'src/components/atoms/CustomInput';
import * as CustomSelector from 'src/components/atoms/CustomSelector';
import * as CustomTextArea from 'src/components/atoms/CustomTextArea';
import * as HeroParagraph from 'src/components/atoms/HeroParagraph';
import * as Icons from 'src/components/atoms/Icons';
import * as Image from 'src/components/atoms/Image';
import * as ImageGrid from 'src/components/atoms/ImageGrid';
import * as PillList from 'src/components/atoms/PillList';
import * as TextBox from 'src/components/atoms/TextBox';
import * as Video from 'src/components/atoms/Video';
import * as HeroComponent from 'src/components/common/HeroComponent';
import * as FilterContext from 'src/components/context/FilterContext';
import * as CareActions from 'src/components/getcarenow/CareActions';
import * as CareScheduleAndChat from 'src/components/getcarenow/CareScheduleAndChat';
import * as DisclaimerWidget from 'src/components/getcarenow/DisclaimerWidget';
import * as GetCareFooter from 'src/components/getcarenow/GetCareFooter';
import * as PageTitle from 'src/components/getcarenow/PageTitle';
import * as BackgroundImage from 'src/components/gic/BackgroundImage';
import * as ContentBlock from 'src/components/gic/ContentBlock';
import * as GICFooter from 'src/components/gic/GICFooter';
import * as GICHeader from 'src/components/gic/GICHeader';
import * as GICLayout from 'src/components/gic/GICLayout';
import * as GICPageGrid from 'src/components/gic/GICPageGrid';
import * as MammogramCard from 'src/components/gic/MammogramCard';
import * as OverviewArrow from 'src/components/gic/OverviewArrow';
import * as PageNavigation from 'src/components/gic/PageNavigation';
import * as YoutubeVideo from 'src/components/gic/YoutubeVideo';
import * as ActionButtonGroup from 'src/components/molecules/ActionButtonGroup';
import * as AdditionalCards from 'src/components/molecules/AdditionalCards';
import * as AlertListingFilters from 'src/components/molecules/AlertListingFilters';
import * as AlertListingGroup from 'src/components/molecules/AlertListingGroup';
import * as AlertProvider from 'src/components/molecules/AlertProvider';
import * as BreadcrumbPrintShare from 'src/components/molecules/BreadcrumbPrintShare';
import * as ButtonModal from 'src/components/molecules/ButtonModal';
import * as ContentSeparator from 'src/components/molecules/ContentSeparator';
import * as CriticalMessage from 'src/components/molecules/CriticalMessage';
import * as EventListItem from 'src/components/molecules/EventListItem';
import * as FeaturedLocations from 'src/components/molecules/FeaturedLocations';
import * as FeaturedProviders from 'src/components/molecules/FeaturedProviders';
import * as FormInput from 'src/components/molecules/FormInput';
import * as FormSelect from 'src/components/molecules/FormSelect';
import * as FormTextArea from 'src/components/molecules/FormTextArea';
import * as FormTextField from 'src/components/molecules/FormTextField';
import * as HospitalLocation from 'src/components/molecules/HospitalLocation';
import * as ImageSelection from 'src/components/molecules/ImageSelection';
import * as InfoMessage from 'src/components/molecules/InfoMessage';
import * as InfoTip from 'src/components/molecules/InfoTip';
import * as IntroParagraph from 'src/components/molecules/IntroParagraph';
import * as PaginationControls from 'src/components/molecules/PaginationControls';
import * as PhotoFeature from 'src/components/molecules/PhotoFeature';
import * as RecipeVideo from 'src/components/molecules/RecipeVideo';
import * as Shapes from 'src/components/molecules/Shapes';
import * as SplitContentCallout from 'src/components/molecules/SplitContentCallout';
import * as SpotlightLocations from 'src/components/molecules/SpotlightLocations';
import * as SpotlightNarrow from 'src/components/molecules/SpotlightNarrow';
import * as SpotlightTall from 'src/components/molecules/SpotlightTall';
import * as StickyCTA from 'src/components/molecules/StickyCTA';
import * as SubNavProvider from 'src/components/molecules/SubNavProvider';
import * as SystemAlertBanner from 'src/components/molecules/SystemAlertBanner';
import * as Toast from 'src/components/molecules/Toast';
import * as Accordion from 'src/components/organisms/Accordion';
import * as AllServices from 'src/components/organisms/AllServices';
import * as ArticleListingFilters from 'src/components/organisms/ArticleListingFilters';
import * as ArticleSummary from 'src/components/organisms/ArticleSummary';
import * as BlogPostDetails from 'src/components/organisms/BlogPostDetails';
import * as BlogSubscribe from 'src/components/organisms/BlogSubscribe';
import * as ContactCard from 'src/components/organisms/ContactCard';
import * as CopyrightFooter from 'src/components/organisms/CopyrightFooter';
import * as EventListing from 'src/components/organisms/EventListing';
import * as EventListingVariations from 'src/components/organisms/EventListingVariations';
import * as FormFieldProvider from 'src/components/organisms/FormFieldProvider';
import * as GetCareHeader from 'src/components/organisms/GetCareHeader';
import * as LinkGroup from 'src/components/organisms/LinkGroup';
import * as LinkList from 'src/components/organisms/LinkList';
import * as MapImage from 'src/components/organisms/MapImage';
import * as MediaCarousel from 'src/components/organisms/MediaCarousel';
import * as MediaViewer from 'src/components/organisms/MediaViewer';
import * as OLDEcardForm from 'src/components/organisms/OLDEcardForm';
import * as OLDEcardImageSelection from 'src/components/organisms/OLDEcardImageSelection';
import * as OSFHeader from 'src/components/organisms/OSFHeader';
import * as OSFNavMobile from 'src/components/organisms/OSFNavMobile';
import * as OSFNavSubLinks from 'src/components/organisms/OSFNavSubLinks';
import * as PLDForm from 'src/components/organisms/PLDForm';
import * as R2Footer from 'src/components/organisms/R2Footer';
import * as R2Header from 'src/components/organisms/R2Header';
import * as R2SearchBar from 'src/components/organisms/R2SearchBar';
import * as R2ZipUpdate from 'src/components/organisms/R2ZipUpdate';
import * as RelatedBlogs from 'src/components/organisms/RelatedBlogs';
import * as RelatedEvents from 'src/components/organisms/RelatedEvents';
import * as RelatedNews from 'src/components/organisms/RelatedNews';
import * as RelatedPressRelease from 'src/components/organisms/RelatedPressRelease';
import * as RelatedRecipes from 'src/components/organisms/RelatedRecipes';
import * as eCard from 'src/components/organisms/eCard';
import * as LocationActionWidget from 'src/components/pld/locations/LocationActionWidget';
import * as LocationApptQuestions from 'src/components/pld/locations/LocationApptQuestions';
import * as LocationBio from 'src/components/pld/locations/LocationBio';
import * as LocationHero from 'src/components/pld/locations/LocationHero';
import * as LocationHours from 'src/components/pld/locations/LocationHours';
import * as LocationInsurance from 'src/components/pld/locations/LocationInsurance';
import * as LocationProfile from 'src/components/pld/locations/LocationProfile';
import * as LocationProvider from 'src/components/pld/locations/LocationProvider';
import * as LocationProviders from 'src/components/pld/locations/LocationProviders';
import * as LocationSearch from 'src/components/pld/locations/LocationSearch';
import * as LocationWidget from 'src/components/pld/locations/LocationWidget';
import * as ProviderBio from 'src/components/pld/providers/ProviderBio';
import * as ProviderHero from 'src/components/pld/providers/ProviderHero';
import * as ProviderInsurance from 'src/components/pld/providers/ProviderInsurance';
import * as ProviderLocation from 'src/components/pld/providers/ProviderLocation';
import * as ProviderLocations from 'src/components/pld/providers/ProviderLocations';
import * as ProviderNextAvailable from 'src/components/pld/providers/ProviderNextAvailable';
import * as ProviderProfile from 'src/components/pld/providers/ProviderProfile';
import * as ProviderReviews from 'src/components/pld/providers/ProviderReviews';
import * as ProviderSchedulingWidget from 'src/components/pld/providers/ProviderSchedulingWidget';
import * as ProviderSearch from 'src/components/pld/providers/ProviderSearch';
import * as ActionBar from 'src/components/pld/shared/ActionBar';
import * as Insurance from 'src/components/pld/shared/Insurance';
import * as LocationsMap from 'src/components/pld/shared/LocationsMap';
import * as ProfileBreadcrumb from 'src/components/pld/shared/ProfileBreadcrumb';
import * as Sidebar from 'src/components/pld/shared/Sidebar';
import * as SliderTabs from 'src/components/pld/shared/SliderTabs';
import * as ActionButton from 'src/components/r2/ActionButton';
import * as AlertListingPage from 'src/components/r2/AlertListingPage';
import * as ArticleListingComponent from 'src/components/r2/ArticleListingComponent';
import * as ArticleSummaryComponent from 'src/components/r2/ArticleSummaryComponent';
import * as Banner from 'src/components/r2/Banner';
import * as BlogAuthor from 'src/components/r2/BlogAuthor';
import * as BlogCategories from 'src/components/r2/BlogCategories';
import * as Breadcrumb from 'src/components/r2/Breadcrumb';
import * as ContentCarousel from 'src/components/r2/ContentCarousel';
import * as ContentCarouselCard from 'src/components/r2/ContentCarouselCard';
import * as ContentCarouselControls from 'src/components/r2/ContentCarouselControls';
import * as ContentListing from 'src/components/r2/ContentListing';
import * as EventDetails from 'src/components/r2/EventDetails';
import * as EventsList from 'src/components/r2/EventsList';
import * as ExpandableContentPromo from 'src/components/r2/ExpandableContentPromo';
import * as FeaturedBlogs from 'src/components/r2/FeaturedBlogs';
import * as FiveUp from 'src/components/r2/FiveUp';
import * as FiveUpCard from 'src/components/r2/FiveUpCard';
import * as FiveUpControls from 'src/components/r2/FiveUpControls';
import * as Footer from 'src/components/r2/Footer';
import * as FooterLinkList from 'src/components/r2/FooterLinkList';
import * as FooterResources from 'src/components/r2/FooterResources';
import * as FooterResourcesList from 'src/components/r2/FooterResourcesList';
import * as FooterSocialBarIcons from 'src/components/r2/FooterSocialBarIcons';
import * as Form from 'src/components/r2/Form';
import * as GeneralContent from 'src/components/r2/GeneralContent';
import * as Header from 'src/components/r2/Header';
import * as ImageCallOut from 'src/components/r2/ImageCallOut';
import * as ImageORVideoContent from 'src/components/r2/ImageORVideoContent';
import * as JoinUsPromo from 'src/components/r2/JoinUsPromo';
import * as JumpSimulationBanner from 'src/components/r2/JumpSimulationBanner';
import * as JumpSimulationBannerTwo from 'src/components/r2/JumpSimulationBannerTwo';
import * as ListFilters from 'src/components/r2/ListFilters';
import * as ListingComponent from 'src/components/r2/ListingComponent';
import * as LogoWall from 'src/components/r2/LogoWall';
import * as Navigation from 'src/components/r2/Navigation';
import * as OLDEcardData from 'src/components/r2/OLDEcardData';
import * as OneUp from 'src/components/r2/OneUp';
import * as Pagination from 'src/components/r2/Pagination';
import * as PullQuote from 'src/components/r2/PullQuote';
import * as RelatedLinks from 'src/components/r2/RelatedLinks';
import * as RightRail from 'src/components/r2/RightRail';
import * as RightRailNavigation from 'src/components/r2/RightRailNavigation';
import * as Search from 'src/components/r2/Search';
import * as SearchData from 'src/components/r2/SearchData';
import * as SixUp from 'src/components/r2/SixUp';
import * as SocialMediaLinks from 'src/components/r2/SocialMediaLinks';
import * as SubScribe from 'src/components/r2/SubScribe';
import * as TabGroup from 'src/components/r2/TabGroup';
import * as Table from 'src/components/r2/Table';
import * as TextCallOut from 'src/components/r2/TextCallOut';
import * as ThreeColumnLayout from 'src/components/r2/ThreeColumnLayout';
import * as ThreeUp from 'src/components/r2/ThreeUp';
import * as TwoColumn from 'src/components/r2/TwoColumn';
import * as GET_BLOG_POSTS from 'src/components/r2/graphql/GET_BLOG_POSTS';
import * as GET_CATEGORIES from 'src/components/r2/graphql/GET_CATEGORIES';
import * as ContentCard from 'src/components/shared/ContentCard';
import * as PictureContentCard from 'src/components/shared/PictureContentCard';
import * as ScriptLoader from 'src/components/shared/ScriptLoader';
import * as SharedContentBlock from 'src/components/shared/SharedContentBlock';
import * as AlertTypes from 'src/components/types/AlertTypes';
import * as ClinicalFocusTypes from 'src/components/types/ClinicalFocusTypes';
import * as Department from 'src/components/types/Department';
import * as ListItem from 'src/components/types/ListItem';
import * as LocationTypes from 'src/components/types/LocationTypes';
import * as OSFHeaderTypes from 'src/components/types/OSFHeaderTypes';
import * as ProviderTypes from 'src/components/types/ProviderTypes';
import * as ScheduleDay from 'src/components/types/ScheduleDay';
import * as SpecialtyTypes from 'src/components/types/SpecialtyTypes';

const components = new Map();
components.set('AhaPdcFeaturedProviders', AhaPdcFeaturedProviders);
components.set('AhaPecArticle', AhaPecArticle);
components.set('ActionLink', ActionLink);
components.set('Button', Button);
components.set('CustomButton', CustomButton);
components.set('CustomInput', CustomInput);
components.set('CustomSelector', CustomSelector);
components.set('CustomTextArea', CustomTextArea);
components.set('HeroParagraph', HeroParagraph);
components.set('Icons', Icons);
components.set('Image', Image);
components.set('ImageGrid', ImageGrid);
components.set('PillList', PillList);
components.set('TextBox', TextBox);
components.set('Video', Video);
components.set('HeroComponent', HeroComponent);
components.set('FilterContext', FilterContext);
components.set('CareActions', CareActions);
components.set('CareScheduleAndChat', CareScheduleAndChat);
components.set('DisclaimerWidget', DisclaimerWidget);
components.set('GetCareFooter', GetCareFooter);
components.set('PageTitle', PageTitle);
components.set('BackgroundImage', BackgroundImage);
components.set('ContentBlock', ContentBlock);
components.set('GICFooter', GICFooter);
components.set('GICHeader', GICHeader);
components.set('GICLayout', GICLayout);
components.set('GICPageGrid', GICPageGrid);
components.set('MammogramCard', MammogramCard);
components.set('OverviewArrow', OverviewArrow);
components.set('PageNavigation', PageNavigation);
components.set('YoutubeVideo', YoutubeVideo);
components.set('ActionButtonGroup', ActionButtonGroup);
components.set('AdditionalCards', AdditionalCards);
components.set('AlertListingFilters', AlertListingFilters);
components.set('AlertListingGroup', AlertListingGroup);
components.set('AlertProvider', AlertProvider);
components.set('BreadcrumbPrintShare', BreadcrumbPrintShare);
components.set('ButtonModal', ButtonModal);
components.set('ContentSeparator', ContentSeparator);
components.set('CriticalMessage', CriticalMessage);
components.set('EventListItem', EventListItem);
components.set('FeaturedLocations', FeaturedLocations);
components.set('FeaturedProviders', FeaturedProviders);
components.set('FormInput', FormInput);
components.set('FormSelect', FormSelect);
components.set('FormTextArea', FormTextArea);
components.set('FormTextField', FormTextField);
components.set('HospitalLocation', HospitalLocation);
components.set('ImageSelection', ImageSelection);
components.set('InfoMessage', InfoMessage);
components.set('InfoTip', InfoTip);
components.set('IntroParagraph', IntroParagraph);
components.set('PaginationControls', PaginationControls);
components.set('PhotoFeature', PhotoFeature);
components.set('RecipeVideo', RecipeVideo);
components.set('Shapes', Shapes);
components.set('SplitContentCallout', SplitContentCallout);
components.set('SpotlightLocations', SpotlightLocations);
components.set('SpotlightNarrow', SpotlightNarrow);
components.set('SpotlightTall', SpotlightTall);
components.set('StickyCTA', StickyCTA);
components.set('SubNavProvider', SubNavProvider);
components.set('SystemAlertBanner', SystemAlertBanner);
components.set('Toast', Toast);
components.set('Accordion', Accordion);
components.set('AllServices', AllServices);
components.set('ArticleListingFilters', ArticleListingFilters);
components.set('ArticleSummary', ArticleSummary);
components.set('BlogPostDetails', BlogPostDetails);
components.set('BlogSubscribe', BlogSubscribe);
components.set('ContactCard', ContactCard);
components.set('CopyrightFooter', CopyrightFooter);
components.set('EventListing', EventListing);
components.set('EventListingVariations', EventListingVariations);
components.set('FormFieldProvider', FormFieldProvider);
components.set('GetCareHeader', GetCareHeader);
components.set('LinkGroup', LinkGroup);
components.set('LinkList', LinkList);
components.set('MapImage', MapImage);
components.set('MediaCarousel', MediaCarousel);
components.set('MediaViewer', MediaViewer);
components.set('OLDEcardForm', OLDEcardForm);
components.set('OLDEcardImageSelection', OLDEcardImageSelection);
components.set('OSFHeader', OSFHeader);
components.set('OSFNavMobile', OSFNavMobile);
components.set('OSFNavSubLinks', OSFNavSubLinks);
components.set('PLDForm', PLDForm);
components.set('R2Footer', R2Footer);
components.set('R2Header', R2Header);
components.set('R2SearchBar', R2SearchBar);
components.set('R2ZipUpdate', R2ZipUpdate);
components.set('RelatedBlogs', RelatedBlogs);
components.set('RelatedEvents', RelatedEvents);
components.set('RelatedNews', RelatedNews);
components.set('RelatedPressRelease', RelatedPressRelease);
components.set('RelatedRecipes', RelatedRecipes);
components.set('eCard', eCard);
components.set('LocationActionWidget', LocationActionWidget);
components.set('LocationApptQuestions', LocationApptQuestions);
components.set('LocationBio', LocationBio);
components.set('LocationHero', LocationHero);
components.set('LocationHours', LocationHours);
components.set('LocationInsurance', LocationInsurance);
components.set('LocationProfile', LocationProfile);
components.set('LocationProvider', LocationProvider);
components.set('LocationProviders', LocationProviders);
components.set('LocationSearch', LocationSearch);
components.set('LocationWidget', LocationWidget);
components.set('ProviderBio', ProviderBio);
components.set('ProviderHero', ProviderHero);
components.set('ProviderInsurance', ProviderInsurance);
components.set('ProviderLocation', ProviderLocation);
components.set('ProviderLocations', ProviderLocations);
components.set('ProviderNextAvailable', ProviderNextAvailable);
components.set('ProviderProfile', ProviderProfile);
components.set('ProviderReviews', ProviderReviews);
components.set('ProviderSchedulingWidget', ProviderSchedulingWidget);
components.set('ProviderSearch', ProviderSearch);
components.set('ActionBar', ActionBar);
components.set('Insurance', Insurance);
components.set('LocationsMap', LocationsMap);
components.set('ProfileBreadcrumb', ProfileBreadcrumb);
components.set('Sidebar', Sidebar);
components.set('SliderTabs', SliderTabs);
components.set('ActionButton', ActionButton);
components.set('AlertListingPage', AlertListingPage);
components.set('ArticleListingComponent', ArticleListingComponent);
components.set('ArticleSummaryComponent', ArticleSummaryComponent);
components.set('Banner', Banner);
components.set('BlogAuthor', BlogAuthor);
components.set('BlogCategories', BlogCategories);
components.set('Breadcrumb', Breadcrumb);
components.set('ContentCarousel', ContentCarousel);
components.set('ContentCarouselCard', ContentCarouselCard);
components.set('ContentCarouselControls', ContentCarouselControls);
components.set('ContentListing', ContentListing);
components.set('EventDetails', EventDetails);
components.set('EventsList', EventsList);
components.set('ExpandableContentPromo', ExpandableContentPromo);
components.set('FeaturedBlogs', FeaturedBlogs);
components.set('FiveUp', FiveUp);
components.set('FiveUpCard', FiveUpCard);
components.set('FiveUpControls', FiveUpControls);
components.set('Footer', Footer);
components.set('FooterLinkList', FooterLinkList);
components.set('FooterResources', FooterResources);
components.set('FooterResourcesList', FooterResourcesList);
components.set('FooterSocialBarIcons', FooterSocialBarIcons);
components.set('Form', Form);
components.set('GeneralContent', GeneralContent);
components.set('Header', Header);
components.set('ImageCallOut', ImageCallOut);
components.set('ImageORVideoContent', ImageORVideoContent);
components.set('JoinUsPromo', JoinUsPromo);
components.set('JumpSimulationBanner', JumpSimulationBanner);
components.set('JumpSimulationBannerTwo', JumpSimulationBannerTwo);
components.set('ListFilters', ListFilters);
components.set('ListingComponent', ListingComponent);
components.set('LogoWall', LogoWall);
components.set('Navigation', Navigation);
components.set('OLDEcardData', OLDEcardData);
components.set('OneUp', OneUp);
components.set('Pagination', Pagination);
components.set('PullQuote', PullQuote);
components.set('RelatedLinks', RelatedLinks);
components.set('RightRail', RightRail);
components.set('RightRailNavigation', RightRailNavigation);
components.set('Search', Search);
components.set('SearchData', SearchData);
components.set('SixUp', SixUp);
components.set('SocialMediaLinks', SocialMediaLinks);
components.set('SubScribe', SubScribe);
components.set('TabGroup', TabGroup);
components.set('Table', Table);
components.set('TextCallOut', TextCallOut);
components.set('ThreeColumnLayout', ThreeColumnLayout);
components.set('ThreeUp', ThreeUp);
components.set('TwoColumn', TwoColumn);
components.set('GET_BLOG_POSTS', GET_BLOG_POSTS);
components.set('GET_CATEGORIES', GET_CATEGORIES);
components.set('ContentCard', ContentCard);
components.set('PictureContentCard', PictureContentCard);
components.set('ScriptLoader', ScriptLoader);
components.set('SharedContentBlock', SharedContentBlock);
components.set('AlertTypes', AlertTypes);
components.set('ClinicalFocusTypes', ClinicalFocusTypes);
components.set('Department', Department);
components.set('ListItem', ListItem);
components.set('LocationTypes', LocationTypes);
components.set('OSFHeaderTypes', OSFHeaderTypes);
components.set('ProviderTypes', ProviderTypes);
components.set('ScheduleDay', ScheduleDay);
components.set('SpecialtyTypes', SpecialtyTypes);

export function componentModule(componentName: string) {
  return components.get(componentName);
};

export function componentFactory(componentName: string) {
  return components.get(componentName)?.default;
};
